import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Menu, Icon, Dropdown, Popup } from 'semantic-ui-react';
import { BACKGROUND_COLOR, PRIMARY_COLOR_HIGHLIGHT } from '../colors';
import {
  TYPE_MENU_ITEM_HEADER,
  TYPE_MENU_ITEM_MENU,
  TYPE_MENU_ITEM_LINK,
  TYPE_MENU_ITEM_DIVIDER,
} from '../constants';
import './index.css';

/**
 * Dropdown Main menu
 * this component builds a main menu on top left
 *
 * Popup window: It is possible to show a popup to the menu items of the first
 * level
 *
 * Props:
 * dropdownMenu: array [
 *   key: string = id menu item
 *   icon: string = name icon
 *   colorIcon: string
 *   type: string
 *         [TYPE_MENU_ITEM_HEADER, TYPE_MENU_ITEM_MENU, TYPE_MENU_ITEM_LINK, TYPE_MENU_ITEM_DIVIDER]
 *   label: string = name
 *   onClick: function
 *   showPopupHover: show Popup by onHover. The popup is only shown by menu items
 *                   type = TYPE_MENU_ITEM_LINK and first level items
 *   popup: array {
 *     title: string
 *     content: object
 *   }
 * ],
 * inverted: bool
 * mobileVersion: bool =  if this field is true, then on the top will be shown only icons
 *   the mobile version should be used by small windows (phones)
 */

export default class DropdownMainMenu extends Component {
  constructor(props) {
    super(props);
    this.createDropdownMenu = this.createDropdownMenu.bind(this);
  }

  createDropdownMenu(menuItems) {
    let trigger = null;
    let dropdownItem;
    return menuItems.map((menuItem, index) => {
      switch (menuItem.type) {
        case TYPE_MENU_ITEM_LINK:
          dropdownItem = (
            <Dropdown.Item
              key={menuItem.key.toString()}
              onClick={() => menuItem.onClick()}
            >
              {menuItem.label}
            </Dropdown.Item>
          );
          return dropdownItem;

        case TYPE_MENU_ITEM_MENU:
          trigger = (
            <span>
              {menuItem.label}
              <Icon name="dropdown" />
            </span>
          );
          return (
            <Dropdown
              item
              key={menuItem.key.toString()}
              icon={false}
              trigger={trigger}
            >
              <Dropdown.Menu>
                {this.createDropdownMenu(menuItem.items)}
              </Dropdown.Menu>
            </Dropdown>
          );
        case TYPE_MENU_ITEM_DIVIDER:
          return <Dropdown.Divider key={index.toString()} />;
        case TYPE_MENU_ITEM_HEADER:
          return (
            <Dropdown.Header key={menuItem.key.toString()}>
              {menuItem.label}
            </Dropdown.Header>
          );
        default:
          return false;
      }
    });
  }

  render() {
    const { dropdownMenu, inverted, mobileVersion } = this.props;
    return (
      <Menu className="main-menu" borderless inverted={inverted}>
        {dropdownMenu.map((menu) => {
          const trigger = (
            <span>
              {menu.icon && <Icon name={menu.icon} size="large" />}
              {!mobileVersion && menu.label}
            </span>
          );
          if (menu.type === TYPE_MENU_ITEM_MENU) {
            return (
              <Dropdown
                item
                trigger={trigger}
                icon={false}
                key={menu.key.toString()}
              >
                <Dropdown.Menu>
                  {this.createDropdownMenu(menu.items)}
                </Dropdown.Menu>
              </Dropdown>
            );
          }
          /* In this case could be only type = TYPE_MENU_ITEM_LINK */
          let menuItem = (
            <Menu.Item
              name={menu.key}
              onClick={() => menu.onClick()}
              key={menu.key.toString()}
            >
              {menu.icon && (
                <Icon
                  name={menu.icon}
                  size="large"
                  style={{ color: menu.colorIcon ? menu.colorIcon : 'none' }}
                />
              )}
              {!mobileVersion && menu.label}
            </Menu.Item>
          );
          /* Menu item without dropdown menu: here it is possible to show a Popup
           * Note: by the option TYPE_MENU_ITEM_MENU it is not possible to show a popup,
           * because by mouseEnter it will be display the dropdown menu
           */
          if (menu.showPopupHover) {
            const style = { backgroundColor: BACKGROUND_COLOR };
            const styleHeader = {
              backgroundColor: PRIMARY_COLOR_HIGHLIGHT,
              color: BACKGROUND_COLOR,
            };
            menuItem = (
              <Popup
                trigger={menuItem}
                on={['hover']}
                basic
                style={style}
                className="popup"
                position="top right"
                hoverable
              >
                {menu.popup.title && (
                  <div className="header" style={styleHeader}>
                    {menu.popup.title}
                  </div>
                )}
                <div className="content">{menu.popup.content}</div>
              </Popup>
            );
          }
          return menuItem;
        })}
      </Menu>
    );
  }
}

DropdownMainMenu.propTypes = {
  dropdownMenu: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      icon: PropTypes.string,
      colorIcon: PropTypes.string,
      type: PropTypes.string,
      label: PropTypes.string,
      onClick: PropTypes.func,
      showPopupHover: PropTypes.bool,
      popup: PropTypes.objectOf(
        PropTypes.shape({
          title: PropTypes.string,
          content: PropTypes.object,
        })
      ),
    })
  ).isRequired,
  inverted: PropTypes.bool,
  mobileVersion: PropTypes.bool,
};

DropdownMainMenu.defaultProps = {
  inverted: false,
  mobileVersion: false,
};
